import type { Language } from '@lumen/platform';
import type { Workspace } from './workspace';

export const WELCOME_MARKDOWN = `Welcome to Lumen! This is your first page. Here are a few things to try:

- [ ] Click anywhere and just start typing
- [ ] Press \`/\` to see all the block types you can add: headings, to-dos, toggles, tables and more
- [ ] Hover over a block and drag the ⋮⋮ handle to move it
- [ ] Select some text to format it, add a link, or leave a comment
- [ ] Press \`Ctrl/⌘ + K\` to search across your workspace

## Make it yours

Add an icon and a cover from the top of the page, create subpages from the sidebar, and invite your team with **Share**.
`;

export const WELCOME_MARKDOWN_NL = `Welkom bij Lumen! Dit is je eerste pagina. Een paar dingen om te proberen:

- [ ] Klik ergens en begin gewoon te typen
- [ ] Druk op \`/\` voor alle soorten blokken: koppen, taken, uitklapblokken, tabellen en meer
- [ ] Ga met de muis over een blok en sleep de ⋮⋮-greep om het te verplaatsen
- [ ] Selecteer tekst om die op te maken, er een link van te maken of er een opmerking bij te plaatsen
- [ ] Druk op \`Ctrl/⌘ + K\` om in je hele werkruimte te zoeken

## Maak het je eigen

Voeg bovenaan de pagina een pictogram en een omslag toe, maak subpagina's vanuit de zijbalk en nodig je team uit met **Delen**.
`;

const WELCOME: Record<Language, { title: string; markdown: string }> = {
  en: { title: 'Getting Started', markdown: WELCOME_MARKDOWN },
  nl: { title: 'Aan de slag', markdown: WELCOME_MARKDOWN_NL },
};

/** Fills a brand-new workspace doc: name, slug, its owner and the "Getting Started" page, in `language` (P-978). */
export function seedWorkspace(ws: Workspace, opts: { name: string; slug: string; owner: { id: string; name: string; email: string; avatar: string | null }; language?: Language }) {
  const welcomePage = WELCOME[opts.language ?? 'en'];
  ws.transact(() => {
    ws.meta.set('name', opts.name);
    ws.meta.set('slug', opts.slug);
    ws.members.set(opts.owner.id, { id: opts.owner.id, name: opts.owner.name, email: opts.owner.email, role: 'owner', avatar: opts.owner.avatar });
    const welcome = ws.createPage({ parent: { type: 'workspace', id: opts.owner.id }, title: welcomePage.title, icon: '👋' });
    ws.setSeedMarkdown(welcome, welcomePage.markdown);
  });
}

